import classNames from "classnames";
import { useState } from "react";
import AscBadgeWithTitleAndDescription from "../AscBadgeWithTitleAndDescription/AscBadgeWithTitleAndDescription";
import { AdminTooltipIcon } from "../AscIcons";
import AscModal from "../AscModal/AscModal";
import styles from "./AscChallengeDescriptionModal.module.scss";
import BackgroundDecoration from "../../assets/illustrations/challenges_modal_background.svg";
import { AscBadgeColor } from "@ascendnow/shared";

export interface AscChallengeDescriptionModalProps {
  className?: string;
  badgeColor?: AscBadgeColor
}

export default function AscChallengeDescriptionModal({
  className,
  badgeColor = "ORANGE",
}: AscChallengeDescriptionModalProps) {
  const [visible, setVisible] = useState(false);

  function openModal() {
    setVisible(true);
  }
  return (
    <div
      data-testid="asc-challenge-description-modal"
      className={classNames(styles.ground, className)}
    >
      <span className={styles.label}>Challenge</span>
      <AdminTooltipIcon className={styles.icon} onClick={openModal} />
      <AscModal
        visible={visible}
        setVisible={setVisible}
        backgroundDecorationUrl={BackgroundDecoration}
        modalClassName={styles.modal}
      >
        <AscBadgeWithTitleAndDescription
          titleClassName={styles.title}
          descriptionClassName={styles.description}
          badgeClassName={styles.badge}
          title="What are Challenges?"
          description="The Edge Challenge is a small activity where you complete daily tasks to earn some points and badges."
          badge={badgeColor}
        />
      </AscModal>
    </div>
  );
}
